<template>
  <v-menu
    top offset-y
    close-delay="250"
  >
    <template v-slot:activator="{ on, attrs }">
      <span class="text-no-wrap" v-bind="attrs" v-on="on">{{ viewMode }}</span>
    </template>

    <v-list dense>
      <v-list-item
        v-for="(viewMode, viewModeId) in $_allViewMode"
        v-bind:key="viewModeId"
        v-on:click="$_selectViewMode(viewMode)"
      >
        <v-list-item-title>{{ viewMode }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import viewMode from './modules/viewMode.js';

export default {
  props: {
    viewMode: { type: String },
  },

  computed: {
    $_allViewMode() { return viewMode },
  },

  methods: {
    $_selectViewMode(viewMode) {
      this.$emit('update:view-mode', viewMode);
    },
  },
}
</script>